import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'NoteToc',

  computed: {
    ...mapGetters('Notes/NoteDetail', {
      mg_currentBulletVideoNotes: 'currentBulletVideoNotes',
      mg_currentBulletQuestionNotes: 'currentBulletQuestionNotes',
    }),
  },

  methods: {
    ...mapMutations('Notes/NoteDetail', {
      mm_SET_NOTE_IDX: 'SET_NOTE_IDX',
    }),

    selectNote(noteIdx) {
      this.mm_SET_NOTE_IDX(noteIdx);
    },

    setCurrentNote(noteIdx) {
      this.selectNote(noteIdx);
      this.$emit('scroll-to-note');
    },
  },
};
